<script setup lang="ts">
import type { ProjectStatus } from "@/types/projects.types";

const props = withDefaults(
  defineProps<{
    status: ProjectStatus;
    clickable?: boolean;
    disabled?: boolean;
    minimal?: boolean;
  }>(),
  {
    disabled: false,
    minimal: false,
    clickable: false,
  }
);

const classes = {
  FINISHED: "status-finished",
  IN_PROGRESS: "status-in-progress",
  READY: "status-ready",
};
</script>

<template>
  <el-tag
    effect="dark"
    class="border-0"
    :class="[
      classes[props.status],
      { 'clickable-badge': clickable, 'cursor-not-allowed': disabled },
    ]"
    ><div class="d-flex flex-row gap-2 align-items-center">
      <div class="filled-circle"></div>
      <span v-if="!minimal">
        {{ $t(`dashboard:projects.status.label.${props.status}`) }}</span
      >
    </div></el-tag
  >
</template>

<style lang="scss" scoped>
.status-finished {
  color: #198754 !important;
  background-color: #19875420;
  .filled-circle {
    background-color: #198754 !important;
  }
}
.status-in-progress {
  color: var(--bs-primary) !important;
  background-color: rgba(var(--bs-primary-rgb), 0.125);
  .filled-circle {
    background-color: var(--bs-primary) !important;
  }
}
.status-ready {
  color: #d08310 !important;
  background-color: #d0831020;
  .filled-circle {
    background-color: #d08310 !important;
  }
}

.clickable-badge {
  cursor: pointer;
  transition: transform 0.1s;
  &:hover {
    transform: scale(1.05);
  }
}

.cursor-not-allowed {
  cursor: not-allowed !important;
  pointer-events: none;
}

.filled-circle {
  width: 6px;
  height: 6px;
  border-radius: 50%;
}
</style>
